// import formatDateTime from 'utils/formatDateTime';

export function getPageTitle(page) {
	return [
		page.id !== 'landing' && page.name,
		'Universal Pictures',
	].filter(e => e).join(' | ');
}

export function getPageCanonicalLink(page) {
	let url = new URL(page.path, 'https://www.universalpictures.com');
	if (page.id === 'leadership' && typeof window !== 'undefined') {
		const qs = new URLSearchParams(window.location.search);
		if (qs.has('name')) {
			url.searchParams.set('name', qs.get('name'));
		}
	}
	return url.href;
}

export function getMetaData(appData, currentPage) {
	let title = getPageTitle(currentPage);
	let image = `${__IMAGE_ROOT__}/share.jpg`;
	let url = getPageCanonicalLink(currentPage);
	let description = 'Official website of Universal Pictures. Watch trailers and get details for current and future movies!';
	let jsonSchema;
	if (currentPage.id === 'landing') {
		jsonSchema = {
			'@context': 'https://schema.org',
			'@type': 'website',
			name: 'Universal Pictures',
			url,
		};
	}

	return {
		title,
		image,
		currentPage,
		url,
		description,
		elements: [
			{ name: 'description', content: description },
			{ name: 'twitter:title', content: title },
			{ name: 'twitter:image', content: image },
			{ name: 'google-site-verification', content: '_BWnI3vobObTPCauutH6jt2KKYDkuwMHtoyaV3M0H0Q' },
			{ property: 'og:title', content: title },
			{ property: 'og:site_name', content: 'Universal Pictures' },
			{ property: 'og:image', content: image },
			{ property: 'og:description', content: description },
		],
		socialLinks: [
			{ name: 'tiktok', url: 'https://www.tiktok.com/@universalpics' },
			{ name: 'youtube', url: 'https://www.youtube.com/UniversalPictures' },
			{ name: 'instagram', url: 'https://www.instagram.com/universalpictures/' },
			{ name: 'facebook', url: 'https://www.facebook.com/universalpictures/' },
			{ name: 'twitter', url: 'https://x.com/UniversalPics' },
			{ name: 'snapchat', url: 'https://www.snapchat.com/add/universalpictures' }
		],
		jsonSchema,
	};
}

export function getMovieMetaData({ title, releaseDate, releaseDateFormatted, url }) {
	// const isoDate = formatDateTime(releaseDate, 'yyyy-MM-dd');
	const description = `${title}, from Universal Pictures. In Theaters ${releaseDateFormatted}.`;
	const fullTitle = `${title} | Universal Pictures`;
	const image = 'https://dx35vtwkllhj9.cloudfront.net/universalstudios/universal-hub/images/share.jpg';

	return {
		title: fullTitle,
		description,
		url,
		image,
		elements: [
			{ name: 'description', content: description },
			{ property: 'og:title', content: fullTitle },
			{ property: 'og:description', content: description },
			{ property: 'og:url', content: url },
			{ property: 'og:type', content: 'video.movie' },
			{ property: 'og:image', content: 'https://dx35vtwkllhj9.cloudfront.net/universalstudios/universal-hub/images/share.jpg' }
			// Twitter tags intentionally omitted
		],
		jsonSchema: {
			'@context': 'https://schema.org',
			'@type': 'Movie',
			url,
			name: title,
			image: 'https://dx35vtwkllhj9.cloudfront.net/universalstudios/universal-hub/images/share.jpg',
			dateCreated: releaseDate,
			description,
			releasedEvent: {
				'@type': 'PublicationEvent',
				location: {
					'@type': 'Country',
					name: 'US'
				},
				startDate: releaseDate
			}
		}
	};
}